import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Experimental_CssVarsProvider as CssVarsProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
const ThemeProvider = React.memo((props) => (_jsxs(CssVarsProvider, { theme: props.theme, children: [_jsx(CssBaseline, {}), props.children] })));
export { ThemeProvider };
//# sourceMappingURL=provider.js.map